<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-05-06 17:15:53
-->
<template>
  <component :is="componentId" :roleText="roleText"></component>
</template>

<script>
import GovProduct from './productList-gov.vue'
import EntProduct from './productList-entInst.vue'
export default {
  data() {
    return {
      roleName: ''
    }
  },
  components: { GovProduct, EntProduct },
  watch: {},
  computed: {
    componentId() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.roleText = this.$store.state.user.userInfo.roleText
      return this.roleText === '机构' || this.roleText === '服务机构'
        ? EntProduct
        : GovProduct
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
</style>

